import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

/**
 * ⚠️ Bu oyna BUTUN ilovada ishlatiladi — matnini o'zgartirmang.
 *    Boshqacha matn kerak bo'lsa (masalan mahsulotni ARXIVGA solish —
 *    o'chirish emas) ixtiyoriy `title` / `body` / `confirmText` /
 *    `confirmClass` berib yuboriladi. Berilmasa hammasi avvalgidek qoladi.
 */
function DeleteModal({ modalDelete, setModalDelete, deleteItem, showNote, setNote,
	title, body, confirmText, confirmClass }) {
	const { t } = useTranslation()

	const head = title || (showNote ? t('are_you_sure_you_want_delete') : t('delete'))
	const text = body || t('are_you_sure_you_want_delete')
	const okText = confirmText || t('delete')
	const okClass = 'btn w-100 ' + (confirmClass || 'btn-danger')

	return (
		<>
			<Modal show={modalDelete?.show ?? modalDelete} animation={false}
				centered dialogClassName="update-modal-width"
				onHide={() => setModalDelete(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{head}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{showNote ?
						<div className="form-group">
							<label>{t('note')}</label>
							<textarea type="text" className="form-control" name="note" value={modalDelete?.note}
								onChange={(e) => setNote({ ...modalDelete, 'note': e.target.value })} />
						</div>
						:
						text
					}
				</Modal.Body>
				<Modal.Footer >
					<div className="d-flex gap-2 w-100">
						<button className="btn btn-warning w-100" onClick={() => setModalDelete(false)}>
							{t('cancel')}
						</button>
						{showNote ?
							<button className={okClass} disabled={!modalDelete?.note?.trim()} onClick={() => deleteItem()}>{okText}</button>
							:
							<button className={okClass} onClick={() => deleteItem()}>{okText}</button>
						}
					</div>
				</Modal.Footer>
			</Modal>
		</>
	)
}

export default DeleteModal
